<template>
  <Table
    class="selection"
    border
    stripe
    :columns="columns"
    :data="selection"
  />
</template>

<script>
export default {
  name: 'search-selectionTable',
  props: {
    selection: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      columns: []
    }
  },
  computed: {
    config () {
      return window.config
    }
  },
  mounted () {
    this.buildSelectionColumns()
  },
  methods: {
    buildSelectionColumns () {
      const columns = [
        {
          title: '已选内容',
          align: 'center',
          children: [
            {
              title: '序号',
              type: 'index',
              width: 70,
              align: 'center'
            }, {
              title: '工程名称',
              key: 'ENG_NAME'
            }, {
              title: '案卷题名',
              key: 'ARCH_TITLE'
            }, {
              title: '文件题名',
              key: 'FILE_TITLE'
            }, {
              title: '操作',
              width: 90,
              align: 'center',
              render: (h, params) => {
                return (
                  <Button
                    type="info"
                    size="small"
                    onClick={ () => this.$emit('on-select-cancel', params.row) }
                  >取消</Button>
                )
              }
            }
          ]
        }
      ]
      this.$set(this, 'columns', columns)
    }
  }
}
</script>

<style lang="scss" scoped>
.selection {
  margin-top: 16px;
}
</style>